import { render, staticRenderFns } from "./ChartProducts.vue?vue&type=template&id=27893a08&"
import script from "./ChartProducts.vue?vue&type=script&lang=js&"
export * from "./ChartProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports